/* RELAX — small progressive enhancements. No dependencies. */
import { StandardEvents } from '@shopify/events';

const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

function publish(name, data) {
  try { window.Shopify?.analytics?.publish?.(name, data); } catch (e) { /* noop */ }
  (window.dataLayer = window.dataLayer || []).push({ event: name, ...data });
}

/* 1) Keep RELAX blocks (savings, per-day, low stock) in sync after a variant change. */
document.addEventListener(
  StandardEvents.productSelect,
  (event) => {
    event.promise
      ?.then(({ detail }) => {
        const html = detail?.html;
        if (!html) return;
        document.querySelectorAll('[data-rx-swap]').forEach((el) => {
          const next = html.querySelector(`[data-rx-swap="${el.dataset.rxSwap}"]`);
          if (next) el.replaceWith(document.importNode(next, true));
        });
      })
      .catch(() => {});
  },
  true
);

/* 2) Analytics: bundle_selected */
document.addEventListener('change', (event) => {
  const input = event.target instanceof Element ? event.target.closest('[data-rx-bundle] input[type="radio"]') : null;
  if (!input) return;
  const picker = input.closest('[data-rx-bundle]');
  publish('bundle_selected', {
    bundle_name: input.value,
    variant_id: input.dataset.variantId,
    product_id: picker?.dataset.productId,
    value: Number(input.dataset.price || 0) / 100,
    currency: 'ILS',
  });
});

/* 3) Cart drawer: refresh from the server after our own cart changes. */
async function refreshDrawer() {
  const [secRes, cartRes] = await Promise.all([
    fetch(`${root}?sections=cart-drawer-section`),
    fetch(`${root}cart.js`),
  ]);
  const sections = await secRes.json();
  const cart = await cartRes.json();
  const doc = new DOMParser().parseFromString(sections['cart-drawer-section'] || '', 'text/html');
  const next = doc.querySelector('.cart-drawer__inner');
  const current = document.querySelector('#cart-drawer .cart-drawer__inner');
  if (next && current) current.replaceWith(document.importNode(next, true));
  document.querySelectorAll('cart-icon').forEach((icon) => icon.renderCartBubble?.(cart.item_count));
}

const json = { 'Content-Type': 'application/json', Accept: 'application/json' };

async function cartAdd(id, quantity) {
  const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: Number(id), quantity }] }) });
  if (!res.ok) throw new Error('add failed');
}

async function withButton(btn, work) {
  const error = btn.closest('.rx-upsell')?.querySelector('[data-rx-upsell-error]');
  btn.disabled = true;
  btn.setAttribute('aria-busy', 'true');
  try {
    await work();
    await refreshDrawer();
  } catch (e) {
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
    if (error) error.hidden = false;
  }
}

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;

  /* 3a) Single upsell item */
  const add = target.closest('[data-rx-upsell]');
  if (add) {
    event.preventDefault();
    withButton(add, async () => {
      await cartAdd(add.dataset.variantId, 1);
      publish('upsell_added', { variant_id: add.dataset.variantId, currency: 'ILS' });
    });
    return;
  }

  /* 3b) Bundle upgrade: replace the single pack with the 2-pack (real variant, real price) */
  const up = target.closest('[data-rx-upgrade]');
  if (up) {
    event.preventDefault();
    withButton(up, async () => {
      const res = await fetch(`${root}cart/change.js`, { method: 'POST', headers: json, body: JSON.stringify({ id: up.dataset.lineKey, quantity: 0 }) });
      if (!res.ok) throw new Error('change failed');
      await cartAdd(up.dataset.variantId, Number(up.dataset.lineQty || 1));
      publish('bundle_upgraded', { variant_id: up.dataset.variantId, currency: 'ILS' });
    });
  }
});
